import React, { useState, useEffect } from "react";
import { Modal, message, Spin } from "antd";
import { ChatCompletionRequest } from "../../model_gen/chat";
import RequestOverview from "./RequestOverview";
import { RequestsService } from "../../services/RequestsService";

interface RequestViewModalProps {
  requestId?: string;
  applicationId?: string;
  applicationActionId?: string;
  isVisible: boolean;
  onClose: () => void;
  apiKey: string;
  modelOptions?: string[];
  request?: ChatCompletionRequest;
}

const RequestViewModal: React.FC<RequestViewModalProps> = ({
  requestId,
  applicationId,
  applicationActionId,
  isVisible,
  onClose,
  apiKey,
  modelOptions = [],
  request: initialRequest,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [request, setRequest] = useState<ChatCompletionRequest | null>(initialRequest || null);

  useEffect(() => {
    // If a request is directly provided, use it
    if (initialRequest) {
      setRequest(initialRequest);
      return;
    }

    // Otherwise fetch the request if needed
    if (isVisible && requestId && applicationId && applicationActionId) {
      setIsLoading(true);
      RequestsService.getRequest(
        applicationId,
        applicationActionId,
        requestId,
        setIsLoading,
        apiKey
      ).subscribe(
        (fetchedRequest: ChatCompletionRequest) => {
          setRequest(fetchedRequest);
          setIsLoading(false);
        },
        (error: any) => {
          console.error("Failed to fetch request:", error);
          message.error("Failed to fetch request");
          setIsLoading(false);
        }
      );
    }
  }, [isVisible, requestId, applicationId, applicationActionId, apiKey, initialRequest]);

  const handleCancel = () => {
    setRequest(null);
    onClose();
  };

  return (
    <Modal
      title="View Request"
      open={isVisible}
      onCancel={handleCancel}
      width={1000}
      bodyStyle={{ maxHeight: "80vh", overflowY: "auto" }}
      footer={null}>
      {isLoading ? (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <Spin />
        </div>
      ) : request ? (
        <RequestOverview
          request={request}
          isEditable={false}
          modelOptions={modelOptions}
          showDetails={false}
          expanded={true}
        />
      ) : null}
    </Modal>
  );
};

export default RequestViewModal; 